import React from "react";
import { memo } from "react";
import CountUp from "react-countup";

const CircularProressBar = ({ percentage }) => {
  return (
    <div
      className="circular_progress_container"
      style={{ "--value": `${124 - (124 * percentage) / 100}` }}
    >
      <div className="circular_progress_outer">
        <div className="circular_progress_inner">
          <div className="circular_progress-numbers" zz>
            <CountUp end={percentage} duration={1.2} />%
          </div>
        </div>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width="44px"
        height="44px"
      >
        <defs>
          <linearGradient id="GradientColor">
            <stop offset="0%" stopColor="#C59331"></stop>
            <stop offset="100%" stopColor="#C59331"></stop>
          </linearGradient>
        </defs>
        <circle cx="22" cy="22" r="20" strokeLinecap="round" />
      </svg>
    </div>
  );
};

export default memo(CircularProressBar);
